import APortalRestrict from './APortalRestrict';

export default APortalRestrict;
